module.exports = __webpack_public_path__ + "static/media/md-cloud.985f537b.svg";